interface AmazonS3PresignedUrlData {
  fields: Record<string, string>;
  url: string;
}

// Image extensions
type ImageExtension = "jpeg" | "jpg" | "png" | "webp";

// Video extensions
type VideoExtension = "mov" | "mp4" | "webm";

// All supported file extensions
type FileExtension = ImageExtension | VideoExtension;

/** The prefixes an upload may land under — the API appends the resource id
    (where there is one) and the file name. Mirrors `StorageFolder`. */
type StorageFolder =
  | "adhoc"
  | "adhoc/groups"
  | "studies/groups"
  | "studies/pictures"
  | "studies/questions"
  | "studies/sections"
  | "temp";

// Helper to check if extension is video
const VIDEO_EXTENSIONS: VideoExtension[] = ["mov", "mp4", "webm"];
const isVideoExtension = (ext: string): ext is VideoExtension =>
  VIDEO_EXTENSIONS.includes(ext as VideoExtension);

export { VIDEO_EXTENSIONS, isVideoExtension };
export type {
  AmazonS3PresignedUrlData,
  FileExtension,
  ImageExtension,
  StorageFolder,
  VideoExtension,
};
